export const GET_ALL_LECTURES = 'GET_ALL_LECTURES'
export const LOAD_LECTURES = 'LOAD_LECTURES'
